import { cn } from '../../../lib/utils';

interface SeparatorProps {
  className?: string;
  /**
   * Drops the implicit `separator` role, for rules that only draw a caption's flanks — the caption
   * already conveys the break, so announcing a separator either side of it is noise.
   */
  decorative?: boolean;
}

/**
 * Hairline rule for separating content within a surface (e.g. inside a `Card`).
 * Defaults to the `card-border` token; pass `className` to override the color or spacing.
 * For the dotted section separator between cards, use `DotDivider` instead.
 */
function Separator({ className, decorative = false }: SeparatorProps) {
  return <hr aria-hidden={decorative || undefined} className={cn('m-0 h-px w-full border-0 bg-card-border', className)} />;
}

export { Separator };
